module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA3CAYAAACo29JGAAAAiklEQVRoge3YMQrAIBAAQQ15i///jn4maQKpLIJBbo+dxkI4WKy82nu/yrr6nKFmHasDIjOOyjgq46iMozKOyjgq46hSx53l/Rz+Yfus1tr0Lv3LhVoNfJ01xpjepX4546iMozKOyjgq46iMozKOKnWcawYq1wxUxlEZR2UclXFUxlEZR2UcVeq4G1K/EgQ7fisaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/allEqualNinths.png
// module id = kwpT
// module chunks = 0